// The Status table's column-visibility toggle: which of its optional columns (Section, Created
// by) are offered at all and what they default to when nothing is stored. Pure, no Vue dependency - same shape as
// `useSlaughtersColumnVisibility`, trimmed to the two columns this page carries: Status has no
// basis-mix concept, so Section defaults on and Created by defaults off. The generic mechanics (storage,
// toggling, select-all) live in the shared `useColumnVisibilityOverrides` composable instead.

import type { StatusRow } from '@/types';

/** The columns a reader can show or hide. Fixed columns (date/location/pigs/weights) are never in
 * here. */
export type StatusToggleColumnId = 'section' | 'created_by';

/** Left-to-right table order of the mutable columns. */
export const TOGGLE_COLUMN_IDS: readonly StatusToggleColumnId[] = ['section', 'created_by'];

/** Whether Section has at least one non-null entry among the given rows. */
export function columnPresence(rows: StatusRow[]): Record<StatusToggleColumnId, boolean> {
    return {
        section: rows.some((row) => row.section !== null),
        created_by: rows.some((row) => row.created_by !== null),
    };
}

/** Section is offered in the dropdown at all only once the loaded rows carry it; Created by is always offered. */
export function isColumnAvailable(columnId: StatusToggleColumnId, presence: Record<StatusToggleColumnId, boolean>): boolean {
    return columnId === 'created_by' || presence[columnId];
}
